// urls
export const resourceUrl = process.env.VUE_APP_RESOURCE_URL;

//i18n
export const i18nLocale = process.env.VUE_APP_I18N_LOCALE;
export const i18nFallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE;
